module.exports = __webpack_public_path__ + "img/game_icon_score.871f11e0.png";